import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Article } from '../../../models/article';
import Typography from '../Typography';
import StoryAuthor from '../StoryAuthor';
import Image from '../Image';

import storyStyles from './Story_styles';
import ColumnBlock from '../../../views/GroupBlock/ColumnBlock/ColumnBlock';

export interface StoryProps {
  slot?: string;
  attribute?: boolean;
  article: Article;
  lazy?: boolean;
  amp?: boolean;
  image?: boolean;
  onClick?: () => any;
}

const Story = ({
  slot,
  onClick,
  lazy = true,
  image = true,
  article: {
    title,
    category,
    category_link,
    link,
    excerpt,
    large_image,
    image_caption,
  },
  styles,
}: StoryProps & StylesProps<typeof storyStyles>) => {
  const articleImage = large_image ?? process.env.ARTICLE_FALLBACK_FEATURE_IMAGE;
  return (
    <div className={cx('Story', styles.container)}>

      <a href={link} title={title} onClick={onClick}>
        {image && (
          <div className={styles.imageContainer}>
            <Image
              alt={image_caption || title}
              className={cx(styles.image, 'Story__image')}
              src={`${articleImage}`}
              aspect={[16, 9]}
              resizeWidth={300}
              lazy={lazy}
            />
          </div>
        )}

        <div id={slot} data-parsely-slot={slot} className={styles.slot}>
          <Typography color={'primary'} linkDecoration={'none'}>
            <a href={category_link} className={styles.category}>{category}</a>
          </Typography>

          <a href={link} title={title} className={styles.link} onClick={onClick}>
            <Typography>
              <h3 className={cx(styles.title, styles.titleMobile, 'Story__title')}>
                {title}
              </h3>

              <div className={styles.bottom}>
                <div className={styles.teaser}>
                  <div className={styles.text}>
                    <h3 className={cx(styles.title, 'Story__title')}>{title}</h3>
                    <Typography className={styles.excerpt} family={'copy'}>
                      <span dangerouslySetInnerHTML={{ __html: excerpt }} />
                    </Typography>
                  </div>
                </div>
              </div>
            </Typography>
          </a>
        </div>
      </a>
    </div>
  );
}

export default styled(storyStyles)(Story);
